/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantDetailsChangeModal from './participant.details.change.component';
import { hideModal, updateParticipantJourney, clearUpdateJourneyError } from '../../actions/actions';

export const mapStateToProps = (state) => {
  return {
    error: state.subject.errorUpdateJourney,
    participantFinalStatuses: state.participantStatus.participantStatuses,
    isLoading: state.participantStatus.isLoading,
    participantJourney: state.subject.participantJourney
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hide: () => {
      dispatch(hideModal());
      dispatch(clearUpdateJourneyError());
    },
    updateParticipantJourney: (participantJourneyGid, payload) => {
      dispatch(updateParticipantJourney(participantJourneyGid, payload));
    }
  };
};

const ParticipantDetailsChangeContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantDetailsChangeModal);

export default ParticipantDetailsChangeContainer;
